import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
  bearer: string;
};
type HookTuple = [
  response: vp.DeleteSignerResponse,
  DeleteSigner: (params: vp.DeleteSignerRequest) => void,
  reset: () => void,
  DeleteSignerAsync: (params: vp.DeleteSignerRequest) => Promise<vp.DeleteSignerResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const userPostDeleteSigner: ApiHook = ({ api, bearer }) => {
  const [shouldDeleteSigner, setShouldDeleteSigner] = useState(false);
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  const [params, setParams] = useState<vp.DeleteSignerRequest>({
    SigningAuthorityID: '',
  });
  const [response, setResponse] = useState<vp.DeleteSignerResponse>({
    Success: false,
    ErrorMessage: '',
    SigningAuthorityID: '',
  });

  useEffect(() => {
    if (!shouldDeleteSigner) return () => {};

    const DeleteSigner = async () => {
      setDataFetchingInfo(true, '', 'fullScreen');
      const res = await api.postDeleteSigner(params, bearer, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldDeleteSigner) DeleteSigner().catch((e) => console.error(e));
    setShouldDeleteSigner(false);
    return () => {
      source.cancel();
    };
  }, [shouldDeleteSigner]);

  return [
    response,
    (_params: vp.DeleteSignerRequest) => {
      setParams(_params);
      setShouldDeleteSigner(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        SigningAuthorityID: '',
      });
      setShouldDeleteSigner(false);
    },
    (_params) => api.postDeleteSigner(_params, bearer, source),
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(userPostDeleteSigner);
